// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"045e8ff9","160":"3d0451a0","208":"62ba3152","293":"e24fb9d4","516":"6153dca5","519":"d3cfc631","917":"8ea976bc","946":"ae63f1ab"}[chunkId] + ".chunk.js";
};